import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledChipsDivider = styled.div`
    ${mixins.setFontVariant("captionTitle", colorsPalettes.carbon[300])}
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin-right: 8px;
`;

export const StyledChipsWrapper = styled(FlexRow)`
    margin-bottom: 8px;
`;

export const StyledChipsContainer = styled(FlexRow)`
    flex-wrap: wrap;
`;
